import { render } from "./SettingsModal.vue?vue&type=template&id=6b8fa85a&scoped=true&ts=true"
import script from "./SettingsModal.vue?vue&type=script&lang=ts"
export * from "./SettingsModal.vue?vue&type=script&lang=ts"

import "./SettingsModal.vue?vue&type=style&index=0&id=6b8fa85a&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b8fa85a"]])

export default __exports__